package com.raouf.mehrguard.web.i18n

internal val IndonesianStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Detektor QRishing Kotlin Multiplatform",
    WebStringKey.MenuMain to "Menu Utama",
    WebStringKey.MenuSecurity to "Keamanan",
    WebStringKey.MenuSystem to "Sistem",
    WebStringKey.NavDashboard to "Dasbor",
    WebStringKey.NavScanMonitor to "Monitor Pemindaian",
    WebStringKey.NavScanHistory to "Riwayat Pemindaian",
    WebStringKey.NavTrustCentre to "Pusat Kepercayaan",
    WebStringKey.NavReports to "Laporan",
    WebStringKey.NavTraining to "Pelatihan",
    WebStringKey.NavSettings to "Pengaturan",
    WebStringKey.QuickActions to "Aksi Cepat",

    // Hero Section
    WebStringKey.HeroTagline to "Aman. Offline.",
    WebStringKey.HeroTagline2 to "Pertahanan Transparan.",
    WebStringKey.HeroDescription to "Mehr Guard menganalisis ancaman potensial langsung di perangkat keras Anda. Nikmati perlindungan tanpa latensi.",

    // Dashboard
    WebStringKey.StartScan to "Mulai Pemindaian Baru",
    WebStringKey.ImportImage to "Impor Gambar",
    WebStringKey.ScanQrCode to "Pindai Kode QR",
    WebStringKey.SystemHealth to "Kesehatan Sistem",
    WebStringKey.ThreatDatabase to "Database Ancaman",
    WebStringKey.Current to "Saat Ini",
    WebStringKey.Active to "Aktif",
    WebStringKey.Threats to "Ancaman",
    WebStringKey.SafeScans to "Pemindaian Aman",
    WebStringKey.EngineActive to "Mesin Aktif",
    WebStringKey.EnterpriseProtection to "Perlindungan Enterprise Aktif",
    WebStringKey.SystemOptimal to "Sistem Optimal",
    WebStringKey.EngineStatus to "Mesin v2.4 • Diperbarui 2j lalu",
    WebStringKey.ThreatsBlocked to "Ancaman Diblokir",
    WebStringKey.AllSystemsOperational to "Semua sistem beroperasi",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Ikhtisar",
    WebStringKey.SectionSecurity to "Keamanan",
    WebStringKey.SectionTraining to "Pelatihan",
    WebStringKey.SectionReports to "Laporan",
    WebStringKey.OfflineReady to "Siap Offline",
    WebStringKey.OfflineDescription to "Database lokal v2.4.1 aktif. Tidak ada data yang meninggalkan perangkat ini.",
    
    // Trust Centre
    WebStringKey.TrustCentreTitle to "Pusat Kepercayaan",
    WebStringKey.OfflineGuarantee to "Jaminan Offline Ketat",
    WebStringKey.OfflineGuaranteeDesc to "Analisis Mehr Guard berjalan sepenuhnya di Neural Engine perangkat Anda. Data URL tidak pernah meninggalkan ponsel Anda.",
    WebStringKey.ThreatSensitivity to "Sensitivitas Ancaman",
    WebStringKey.ResetConfirm to "Ini akan mengatur ulang semua pengaturan Pusat Kepercayaan ke default.",
    
    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Monitor Ancaman",
    WebStringKey.ThreatMonitorDesc to "Lihat ancaman langsung dan jalankan audit keamanan",
    WebStringKey.TrustCentreDesc to "Pengaturan privasi dan sensitivitas ancaman",
    WebStringKey.ExportReport to "Ekspor Laporan",
    WebStringKey.ExportReportDesc to "Buat laporan keamanan PDF atau JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Analisis",
    WebStringKey.HeuristicEngine to "Mesin Heuristik",
    WebStringKey.HighPerformanceEngine to "Mesin Performa Tinggi",
    WebStringKey.RecentScans to "Pemindaian Terbaru",
    WebStringKey.ViewFullHistory to "Lihat Riwayat Lengkap",
    WebStringKey.Status to "Kondisi",
    WebStringKey.Source to "Sumber",
    WebStringKey.Details to "Detail",
    WebStringKey.Time to "Waktu",
    WebStringKey.Version to "Versi",
    WebStringKey.LastUpdate to "Pembaruan Terakhir",
    WebStringKey.Signatures to "Tanda Tangan",
    WebStringKey.CheckForUpdates to "Periksa Pembaruan",
    WebStringKey.FeatureOfflineTitle to "Arsitektur Offline-First",
    WebStringKey.FeatureOfflineDesc to "Analisis lengkap dilakukan secara lokal. Feed kamera dan data yang dipindai tidak pernah menyentuh server eksternal, memastikan privasi mutlak.",
    WebStringKey.FeatureExplainableTitle to "Keamanan yang Dapat Dijelaskan",
    WebStringKey.FeatureExplainableDesc to "Jangan hanya mendapat \"Blokir\". Kami menyediakan analisis heuristik terperinci dari parameter URL, redirect, dan payload JavaScript.",
    WebStringKey.FeaturePerformanceDesc to "Dioptimalkan untuk lingkungan desktop. Pemindaian diproses dalam waktu kurang dari 5ms menggunakan biner Kotlin Multiplatform native.",
    WebStringKey.TrainingCentre to "Pusat Pelatihan",
    WebStringKey.LearnHomograph to "Pelajari cara mengidentifikasi serangan homograf QR tingkat lanjut.",
    WebStringKey.BeatTheBotAction to "Kalahkan Bot →",
    WebStringKey.NoScansYet to "Belum ada pemindaian. Mulai pemindaian baru untuk melihat hasil di sini.",
    WebStringKey.VerdictSafe to "AMAN",
    WebStringKey.VerdictPhish to "PHISHING",
    WebStringKey.VerdictWarn to "PERINGATAN",
    WebStringKey.ScoreLabel to "Skor:",

    // Scanner
    WebStringKey.ActiveScanner to "Pemindai Aktif",
    WebStringKey.OfflineMode to "Mode Offline",
    WebStringKey.LiveFeedDisconnected to "FEED LANGSUNG TERPUTUS",
    WebStringKey.CameraAccessRequired to "Akses Kamera Diperlukan",
    WebStringKey.CameraAccessDescription to "Seret & lepas gambar kode QR di sini atau aktifkan akses kamera untuk mulai memindai.",
    WebStringKey.EnableCamera to "Aktifkan Kamera",
    WebStringKey.Scanning to "Memindai...",
    WebStringKey.ScanHint to "Tahan stabil. Dianalisis offline dalam <5ms.",
    WebStringKey.Torch to "Senter",
    WebStringKey.Gallery to "Galeri",
    WebStringKey.PasteUrl to "Tempel URL",
    WebStringKey.PasteUrlTitle to "Tempel URL untuk Dianalisis",
    WebStringKey.AnalyzeUrl to "Analisis URL",
    WebStringKey.SystemStatus to "Status Sistem",
    WebStringKey.PhishingEngine to "Mesin Phishing",
    WebStringKey.Ready to "SIAP",
    WebStringKey.LocalDb to "DB Lokal",
    WebStringKey.Latency to "Latensi",
    WebStringKey.ViewAll to "Lihat Semua",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Beranda",
    WebStringKey.BreadcrumbScans to "Pemindaian",
    WebStringKey.OfflineProtection to "Perlindungan Offline",
    WebStringKey.VerdictHighRisk to "RISIKO TINGGI TERDETEKSI",
    WebStringKey.VerdictDangerous to "Berbahaya",
    WebStringKey.VerdictDangerousDesc to "Kode QR yang dipindai mengandung indikator berbahaya terkait phishing dan pengumpulan kredensial. Jangan lanjutkan ke URL target.",
    WebStringKey.ThreatConfidence to "Kepercayaan Ancaman",
    WebStringKey.FlagPhishing to "Upaya Phishing",
    WebStringKey.FlagObfuscated to "Skrip Terenkripsi",
    WebStringKey.FlagHomograph to "Serangan Homograf",
    WebStringKey.ClearHistory to "Hapus Semua",
    WebStringKey.SectionAttackBreakdown to "Rincian Serangan",
    WebStringKey.AttackHomographTitle to "Serangan Homograf / IDN",
    WebStringKey.AttackHomographDesc to "Karakter Sirilik yang meniru alfabet Latin terdeteksi.",
    WebStringKey.AttackVisualLabel to "Tampilan Visual",
    WebStringKey.AttackPunycodeLabel to "Punycode Aktual",
    WebStringKey.AttackHomographExplain to "Domain menggunakan 'а' Sirilik (U+0430) bukan 'a' Latin (U+0061). Teknik ini biasanya digunakan untuk mengelabui pengguna agar percaya bahwa mereka mengunjungi layanan yang sah.",
    WebStringKey.AttackRedirectTitle to "Rantai Redirect Mencurigakan",
    WebStringKey.AttackRedirectDesc to "3 hop terdeteksi melibatkan layanan pemendekan URL yang dikenal.",
    WebStringKey.RedirectStart to "Pemindaian Kode QR",
    WebStringKey.RedirectHop to "Hop Perantara",
    WebStringKey.RedirectFinal to "Tujuan Akhir",
    WebStringKey.AttackJsTitle to "JavaScript Terenkripsi",
    WebStringKey.AttackJsDesc to "String entropi tinggi terdeteksi dalam parameter URL.",
    WebStringKey.SectionActions to "Tindakan yang Disarankan",
    WebStringKey.ActionBlock to "Blokir & Laporkan",
    WebStringKey.ActionBlockDesc to "Cegah akses dan beri tahu admin",
    WebStringKey.ActionQuarantine to "Karantina di Sandbox",
    WebStringKey.ActionQuarantineDesc to "Buka dengan aman untuk analisis",
    WebStringKey.Expected to "Diharapkan: ",
    WebStringKey.Detected to "Terdeteksi: ",
    WebStringKey.ExplainableSecurity to "Keamanan Transparan",
    WebStringKey.UrlBreakdown to "RINCIAN URL",
    WebStringKey.FullUrl to "URL LENGKAP",
    WebStringKey.OpenInBrowser to "Buka di Browser (Berisiko)",
    WebStringKey.OpenWarning to "Membuka URL ini di browser Anda dapat membuat Anda terpapar risiko keamanan.",
    WebStringKey.RestrictedMode to "Mode Terbatas",
    WebStringKey.RestrictedDesc to "URL ini telah ditandai sebagai berpotensi berbahaya. Tinjau analisis di bawah sebelum melanjutkan.",
    WebStringKey.DangerousWarning to "URL ini telah ditandai sebagai berpotensi berbahaya. Membukanya dapat membuat Anda terpapar phishing, malware, atau ancaman keamanan lainnya. Apakah Anda yakin ingin melanjutkan?",
    WebStringKey.CopyUrl to "Salin URL",
    WebStringKey.Share to "Bagikan",
    WebStringKey.Dismiss to "Tutup",
    WebStringKey.ReasonDomainAge to "Usia domain kurang dari 24 jam.",
    WebStringKey.ReasonSignatures to "Cocok dengan 3 tanda tangan di DB phishing lokal.",
    WebStringKey.ReasonAsn to "IP target berlokasi di ASN berisiko tinggi.",
    WebStringKey.SectionMeta to "Meta Pemindaian",
    WebStringKey.MetaTime to "Waktu Pemindaian",
    WebStringKey.MetaSource to "Sumber",
    WebStringKey.MetaEngine to "Mesin",
    WebStringKey.MetaOfflineGuaranteeLabel to "Jaminan Offline:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Gambar ini dianalisis secara lokal di perangkat Anda. Tidak ada data yang dikirim ke cloud untuk putusan ini.",
    
    // Results Page
    WebStringKey.ScanComplete to "Pemindaian Selesai",
    WebStringKey.Loading to "Memuat...",
    WebStringKey.AnalyzedOffline to "Dianalisis offline dalam <5ms",
    WebStringKey.NoDataLeaves to "Data tidak meninggalkan perangkat",
    WebStringKey.ActiveProtection to "Perlindungan Aktif",
    WebStringKey.ConfidenceScore to "Skor Kepercayaan",
    WebStringKey.Analyzing to "MENGANALISIS...",
    WebStringKey.ProcessingResults to "Memproses hasil pemindaian...",
    WebStringKey.RiskAssessment to "Penilaian Risiko",
    WebStringKey.AnalysisTime to "Waktu Analisis",
    WebStringKey.Heuristics to "Heuristik",
    WebStringKey.TopAnalysisFactors to "Faktor Analisis Utama",
    WebStringKey.Pass to "LULUS",
    WebStringKey.Info to "INFO",
    WebStringKey.Clean to "BERSIH",
    WebStringKey.ValidSslCertificate to "Sertifikat SSL Valid",
    WebStringKey.SslCertificateDesc to "Sertifikat dikeluarkan oleh DigiCert Inc.",
    WebStringKey.EstablishedDomain to "Domain Mapan",
    WebStringKey.EstablishedDomainDesc to "Domain terdaftar >5 tahun lalu.",
    WebStringKey.BlacklistStatus to "Status Daftar Hitam",
    WebStringKey.BlacklistStatusDesc to "Tidak ditemukan di 52 database ancaman lokal.",
    WebStringKey.BackToDashboard to "Kembali ke Dasbor",
    WebStringKey.ShareReport to "Bagikan Laporan",
    WebStringKey.CopyLink to "Salin Tautan",
    WebStringKey.LinkCopied to "Tautan disalin ke clipboard!",
    WebStringKey.BeatTheBot to "Kalahkan Bot",
    WebStringKey.BeatTheBotDesc to "Tantang AI offline kami.",
    WebStringKey.SessionId to "ID Sesi",
    WebStringKey.EndSession to "Akhiri Sesi",
    WebStringKey.Round to "Ronde",
    WebStringKey.BrowserPreview to "Pratinjau Browser",
    WebStringKey.MakeDecision to "Buat keputusan Anda",
    WebStringKey.Phishing to "Pengelabuan",
    WebStringKey.Legitimate to "Sah",
    WebStringKey.LiveHint to "Petunjuk Langsung",
    WebStringKey.LiveScoreboard to "Papan Skor Langsung",
    WebStringKey.VsMode to "MODE VS",
    WebStringKey.You to "Anda",
    WebStringKey.Points to "poin",
    WebStringKey.Streak to "Beruntun",
    WebStringKey.Accuracy to "Akurasi",
    WebStringKey.MehrGuardBot to "Bot Mehr Guard",
    WebStringKey.Confidence to "Kepercayaan",
    WebStringKey.RoundAnalysis to "Analisis Ronde",
    WebStringKey.Analysis to "Analisis",
    WebStringKey.CorrectDecision to "Keputusan Benar!",
    WebStringKey.IdentifiedSafe to "Anda mengidentifikasi URL aman dengan benar.",
    WebStringKey.AiNeuralAnalysis to "Analisis Neural AI",
    WebStringKey.WhyBotFlagged to "Mengapa bot menandai",
    WebStringKey.EducationalNote to "Catatan Edukatif",
    WebStringKey.Correct to "Benar!",
    WebStringKey.SpottedPhishing to "Anda mendeteksi URL phishing dengan benar.",
    WebStringKey.Response to "Respons",
    WebStringKey.NextRound to "Ronde Berikutnya",
    WebStringKey.GameOver to "Permainan Selesai!",
    WebStringKey.FinalResults to "Hasil Akhir",
    WebStringKey.YourScore to "Skor Anda",
    WebStringKey.BotScore to "Skor Bot",
    WebStringKey.BestStreak to "Beruntun Terbaik",
    WebStringKey.PlayAgain to "Main Lagi",
    WebStringKey.ReturnToDashboard to "Kembali ke Dasbor",
    WebStringKey.ExportSecurityReport to "Ekspor Laporan Keamanan",
    WebStringKey.GenerateReport to "Buat laporan keamanan lengkap.",
    WebStringKey.ReportFormat to "Format Laporan",
    WebStringKey.HumanReadable to "Laporan Dapat Dibaca Manusia",
    WebStringKey.HumanReadableDesc to "PDF dengan analisis visual",
    WebStringKey.MachineReadable to "Data Dapat Dibaca Mesin",
    WebStringKey.MachineReadableDesc to "Format JSON untuk integrasi SIEM",
    WebStringKey.DateRange to "Rentang Tanggal",
    WebStringKey.Last7Days to "7 Hari Terakhir",
    WebStringKey.Last30Days to "30 Hari Terakhir",
    WebStringKey.Last90Days to "90 Hari Terakhir",
    WebStringKey.AllTime to "Semua Waktu",
    WebStringKey.CustomRange to "Rentang Kustom",
    WebStringKey.ReportSections to "Bagian Laporan",
    WebStringKey.ExecutiveSummary to "Ringkasan Eksekutif",
    WebStringKey.ThreatBreakdown to "Rincian Ancaman",
    WebStringKey.ScanTimeline to "Timeline Pemindaian",
    WebStringKey.SafeUrlList to "Daftar URL Aman",
    WebStringKey.GenerateExport to "Ekspor Laporan",
    WebStringKey.Success to "Berhasil!",
    WebStringKey.Error to "Kesalahan",
    WebStringKey.Warning to "Peringatan",
    WebStringKey.CopiedToClipboard to "Disalin ke clipboard",
    WebStringKey.Cancel to "Batal",
    WebStringKey.Confirm to "Konfirmasi",
    WebStringKey.Save to "Simpan",
    WebStringKey.Delete to "Hapus",
    WebStringKey.Edit to "Ubah",
    WebStringKey.Close to "Tutup",
    WebStringKey.Back to "Kembali",
    WebStringKey.Next to "Berikutnya",
    WebStringKey.Previous to "Sebelumnya",
    WebStringKey.Submit to "Kirim",
    WebStringKey.Reset to "Atur Ulang",
    WebStringKey.Clear to "Hapus",
    WebStringKey.Search to "Cari",
    WebStringKey.Filter to "Saring",
    WebStringKey.Sort to "Urutkan",
    WebStringKey.ToggleMenu to "Toggle Menu",
    WebStringKey.ToggleTheme to "Toggle Tema",
    WebStringKey.Notifications to "Notifikasi",
    WebStringKey.Help to "Bantuan",
    WebStringKey.Profile to "Profil",
    WebStringKey.ToggleLightDarkMode to "Toggle Mode Terang/Gelap",
    WebStringKey.UrlInputPlaceholder to "Tempel URL untuk dianalisis",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.Scan to "Pemindaian",
    WebStringKey.Result to "Hasil",
    WebStringKey.ReportGeneration to "Pembuatan Laporan",
    WebStringKey.ReportGenerationDesc to "Konfigurasikan format dan unduh analisis.",
    WebStringKey.OfflineSecurity to "Keamanan Offline",
    WebStringKey.OfflineSecurityDesc to "Data Anda tidak pernah meninggalkan perangkat ini.",
    WebStringKey.ChooseFormat to "Pilih Format",
    WebStringKey.PdfFormatDesc to "Format PDF. Terbaik untuk berbagi.",
    WebStringKey.JsonFormatDesc to "Format JSON. Terbaik untuk SIEM.",
    WebStringKey.Copy to "Salin",
    WebStringKey.LivePreview to "Pratinjau Langsung",
    WebStringKey.ReadOnly to "Hanya Baca",
    WebStringKey.ThreatAnalysisReport to "Laporan Analisis Ancaman",
    WebStringKey.Verdict to "Putusan",
    WebStringKey.RiskScore to "Skor Risiko",
    WebStringKey.TargetUrl to "URL Target",
    WebStringKey.AnalysisSummaryLabel to "Ringkasan Analisis",
    WebStringKey.TechnicalIndicators to "Indikator Teknis",
    WebStringKey.ExportInfoNote to "Ekspor mencakup semua vektor ancaman.",
    WebStringKey.AllowList to "Daftar Izin",
    WebStringKey.BlockList to "Daftar Blokir",
    WebStringKey.AddDomain to "Tambah Domain",
    WebStringKey.RemoveDomain to "Hapus Domain",
    WebStringKey.TrustedDomains to "Domain Terpercaya",
    WebStringKey.BlockedDomains to "Domain Diblokir",
    WebStringKey.DomainPlaceholder to "Masukkan domain",
    WebStringKey.Safe to "Aman",
    WebStringKey.TimeAgo to "yang lalu",
    WebStringKey.MinutesAgo to "menit lalu",
    WebStringKey.HoursAgo to "jam lalu",
    WebStringKey.Critical to "KRITIS",
    WebStringKey.Warn to "PERINGATAN",
    WebStringKey.PhishingDetectionSensitivity to "Sensitivitas Deteksi Phishing",
    WebStringKey.SensitivityDescription to "Sesuaikan ambang heuristik.",
    WebStringKey.SensitivityLow to "Rendah",
    WebStringKey.SensitivityBalanced to "Seimbang",
    WebStringKey.SensitivityParanoia to "Maksimum",
    WebStringKey.BalancedModeRecommended to "Mode Seimbang (Direkomendasikan)",
    WebStringKey.BalancedModeDesc to "Memindai pola berbahaya.",
    WebStringKey.LowSensitivityMode to "Mode Sensitivitas Rendah",
    WebStringKey.LowSensitivityModeDesc to "Hanya memblokir URL berbahaya yang diketahui dari database ancaman. Minimal false positive, tetapi mungkin melewatkan serangan baru.",
    WebStringKey.ParanoiaMode to "Mode Paranoia",
    WebStringKey.ParanoiaModeDesc to "Perlindungan maksimal. Memblokir pola mencurigakan apa pun termasuk domain yang baru terdaftar, TLD yang tidak umum, dan URL apa pun dengan trik encoding potensial.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard menggunakan mesin analisis heuristik lokal. Tidak ada data gambar, string URL, atau metadata yang meninggalkan perangkat ini selama pemindaian. Privasi Anda dijamin secara matematis.",
    WebStringKey.SignalBrandImpersonation to "Potensi peniruan merek terdeteksi",
    WebStringKey.SignalCredentialParams to "Parameter terkait kredensial di URL",
    WebStringKey.SignalEncodedPayload to "Data terenkode terdeteksi di parameter query",
    WebStringKey.SignalExcessiveSubdomains to "Kedalaman subdomain berlebihan ({count} level)",
    WebStringKey.SignalHighEntropyHost to "Keacakan tinggi pada nama domain",
    WebStringKey.SignalHomographAttack to "Domain mengandung karakter homograf/membingungkan",
    WebStringKey.SignalHttpNotHttps to "Menggunakan protokol HTTP tidak aman",
    WebStringKey.SignalIpAddressHost to "Host adalah alamat IP bukan domain",
    WebStringKey.SignalLongUrl to "URL terlalu panjang ({length} karakter)",
    WebStringKey.SignalLongUrlMarketing to "URL terlalu panjang ({length} karakter) - mengandung parameter marketing",
    WebStringKey.SignalNewlyRegisteredDomain to "Domain baru terdaftar terdeteksi",
    WebStringKey.SignalNonStandardPort to "Port non-standar: {port}",
    WebStringKey.SignalNumericSubdomain to "Subdomain hanya angka terdeteksi",
    WebStringKey.SignalSuspiciousPathKeywords to "Kata kunci mencurigakan di path ({count} ditemukan)",
    WebStringKey.SignalSuspiciousTld to "TLD mencurigakan: {tld}",
    WebStringKey.SignalUrlShortener to "Menggunakan layanan pemendek URL",
    WebStringKey.SecureEnvironment to "Lingkungan Aman",
    WebStringKey.LearnLocalArchitecture to "Pelajari arsitektur lokal kami",
    WebStringKey.NoCustomDomainsBlocked to "Tidak ada domain kustom yang diblokir.",
    WebStringKey.AddManually to "Tambah secara manual",
    WebStringKey.AddedDaysAgo to "Ditambahkan 2 hari lalu",
    WebStringKey.AddedWeekAgo to "Ditambahkan 1 minggu lalu",
    WebStringKey.PrivacyControls to "Kontrol Privasi",
    WebStringKey.StrictOfflineMode to "Mode Offline Ketat",
    WebStringKey.DisableExternalPreviews to "Nonaktifkan pratinjau eksternal.",
    WebStringKey.AnonymousTelemetry to "Telemetri Anonim",
    WebStringKey.ShareDetectionStats to "Bagikan statistik deteksi.",
    WebStringKey.AutoCopySafeLinks to "Salin Otomatis Tautan Aman",
    WebStringKey.CopyTrustedUrls to "Salin URL terpercaya.",
    WebStringKey.AboutMehrGuard to "Tentang Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Lisensi Open Source",
    WebStringKey.PrivacyPolicy to "Kebijakan Privasi",
    WebStringKey.Acknowledgements to "Pengakuan",
    WebStringKey.ResetAllSettings to "Reset Semua Pengaturan",
    WebStringKey.AddToAllowlist to "Tambah ke Daftar Izin",
    WebStringKey.AddToBlocklist to "Tambah ke Daftar Blokir",
    WebStringKey.AnalysedOfflineTitle to "Dianalisis offline.",
    WebStringKey.YourDataStaysOnDevice to "Data Anda tetap di perangkat.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard memproses setiap pemindaian dengan analisis aman di perangkat.",
    WebStringKey.OnDeviceAnalysis to "Analisis Di Perangkat",
    WebStringKey.OnDeviceAnalysisDesc to "Semua deteksi ancaman berjalan lokal.",
    WebStringKey.NoCloudLogs to "Tanpa Log Cloud",
    WebStringKey.NoCloudLogsDesc to "Kami menonaktifkan telemetri keluar.",
    WebStringKey.OnDeviceDB to "Database Di Perangkat",
    WebStringKey.OnDeviceDBDesc to "Database tanda tangan ancaman lengkap.",
    WebStringKey.DataLifecycleVerification to "Verifikasi Siklus Hidup Data",
    WebStringKey.SecurityAuditPass to "Audit Keamanan: LULUS",
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc.",
    WebStringKey.Support to "Dukungan",
    WebStringKey.Terms to "Ketentuan",
    WebStringKey.SystemsOperational to "Sistem Beroperasi",
    WebStringKey.SystemSecure to "Sistem Aman",
    WebStringKey.VersionStatus to "v2.4.1 • Sistem Aman",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2025.12.29",
    WebStringKey.VerifiedBy to "Diverifikasi oleh Mehr Guard Enterprise",
    WebStringKey.SampleUserName to "Budi Santoso",
    WebStringKey.SampleUserRole to "Analis Keamanan",
    WebStringKey.DetailLabel to "Label Detail",
    WebStringKey.DetailValue to "Nilai Detail",
    WebStringKey.Suspicious to "Mencurigakan",
    WebStringKey.IncorrectDecision to "Keputusan Salah",
    WebStringKey.WrongAnswer to "Ups! Itu salah.",
    WebStringKey.ResponseTime to "Waktu Respons",
    WebStringKey.IncomingMessage to "Pesan Masuk",
    WebStringKey.CertificateIssuer to "Penerbit sertifikat cocok",
    WebStringKey.DomainAgeTrust to "Usia domain > 5 tahun",
    WebStringKey.WhitelistedRank to "Alexa top 1k dalam daftar putih",
    WebStringKey.GameEducationalNote to "Catatan Edukatif",
    WebStringKey.GameHintTitle to "Petunjuk Permainan",
    WebStringKey.AddToAllowlistTitle to "Tambah ke Daftar Izin",
    WebStringKey.AddToBlocklistTitle to "Tambah ke Daftar Blokir",
    WebStringKey.EnterDomainPrompt to "Masukkan domain",
    WebStringKey.LatencyMs to "Latensi",
    WebStringKey.StreakFire to "Beruntun",
    WebStringKey.AccuracyPercent to "Akurasi",
    WebStringKey.ConfidencePercent to "Kepercayaan",
    WebStringKey.English to "Inggris",
    WebStringKey.German to "Jerman",
    WebStringKey.Spanish to "Spanyol",
    WebStringKey.French to "Prancis",
    WebStringKey.ChineseSimplified to "Cina (Sederhana)",
    WebStringKey.Japanese to "Jepang",
    WebStringKey.Hindi to "Bahasa Hindi",
    WebStringKey.Arabic to "Arab",
    WebStringKey.Indonesian to "Indonesia",
    WebStringKey.Italian to "Italia",
    WebStringKey.Korean to "Korea",
    WebStringKey.Portuguese to "Portugis",
    WebStringKey.Russian to "Rusia",
    WebStringKey.Thai to "Thai",
    WebStringKey.Turkish to "Turki",
    WebStringKey.Vietnamese to "Vietnam"
,
    WebStringKey.ComponentVoting to "Pemungutan Suara Komponen",
    WebStringKey.Heuristic to "Heuristik",
    WebStringKey.MLModel to "Model ML",
    WebStringKey.Brand to "Merek",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Suara mayoritas menentukan keputusan: 3+ AMAN = hijau, 2+ BERBAHAYA = merah"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Menunggu pemindaian...",
    WebStringKey.WaitingForAnalysis to "Menunggu analisis...",
    WebStringKey.ScanURLToSeeResults to "Pindai URL untuk melihat hasil terperinci.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Pintasan Keyboard",
    WebStringKey.StartScanner to "Mulai Pemindai",
    WebStringKey.CloseMenuModal to "Tutup Menu / Modal",
    WebStringKey.NavigateToDashboard to "Ke Dasbor",
    WebStringKey.NavigateToHistory to "Riwayat Pemindaian",
    WebStringKey.NavigateToTrust to "Pusat Kepercayaan / Daftar Izin",
    WebStringKey.NavigateToGame to "Game Kalahkan Bot",
    WebStringKey.ShowHelp to "Tampilkan Bantuan",
    WebStringKey.GotIt to "Mengerti",
    WebStringKey.SecuritySettings to "Pengaturan Keamanan",
    WebStringKey.SensitivityLevel to "Tingkat Sensitivitas",
    WebStringKey.AutoBlockThreats to "Blokir Ancaman Otomatis",
    WebStringKey.RealTimeScanning to "Pemindaian Real-Time",
    WebStringKey.SoundAlerts to "Peringatan Suara",
    WebStringKey.ThreatAlerts to "Peringatan Ancaman",
    WebStringKey.ShowConfidenceScore to "Tampilkan Skor Kepercayaan",
    WebStringKey.CompactView to "Tampilan Ringkas",
    WebStringKey.ResetDefaults to "Reset ke Default",
    WebStringKey.SaveAndContinue to "Simpan & Lanjutkan",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "AKTIVITAS MENCURIGAKAN",
    WebStringKey.VerdictWarning to "Peringatan",
    WebStringKey.VerdictSuspiciousDesc to "Kode QR yang dipindai menunjukkan pola mencurigakan yang mungkin mengindikasikan risiko keamanan potensial. Lanjutkan dengan hati-hati.",
    WebStringKey.VerdictMinorConcerns to "KEKHAWATIRAN KECIL",
    WebStringKey.VerdictCaution to "Perhatian",
    WebStringKey.VerdictMinorConcernsDesc to "Beberapa kekhawatiran keamanan kecil teridentifikasi. Tautan tampak sebagian besar aman tetapi disarankan untuk ditinjau.",
    WebStringKey.VerdictVerifiedSafe to "TERVERIFIKASI AMAN",
    WebStringKey.VerdictSafeLabel to "Aman",
    WebStringKey.VerdictVerifiedSafeDesc to "Tidak ada ancaman keamanan yang terdeteksi. Kode QR mengarah ke tujuan aman yang terverifikasi.",
    WebStringKey.VerdictNoActivity to "Tidak Ada Aktivitas",
    WebStringKey.VerdictAwaitingScan to "Menunggu Pemindaian",
    WebStringKey.VerdictNoActivityDesc to "Tidak ada data pemindaian yang tersedia. Silakan pindai kode QR atau masukkan URL untuk dianalisis.",
    WebStringKey.ScanQrToSeeActivity to "Pindai kode QR untuk melihat aktivitas Anda di sini",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Titik Data",
    WebStringKey.ProcessingEnv to "Lingkungan Pemrosesan",
    WebStringKey.ExternalTransmission to "Transmisi Eksternal",
    WebStringKey.RawImageBuffer to "Buffer Gambar Mentah",
    WebStringKey.LocalMemoryRam to "Memori Lokal (RAM)",
    WebStringKey.TransmissionNone to "Tidak Ada",
    WebStringKey.DecodedUrlPayload to "URL/Payload yang Didekode",
    WebStringKey.LocalAnalysis to "Analisis Lokal",
    WebStringKey.ThreatVerdictLabel to "Keputusan Ancaman",
    WebStringKey.LocalDatabase to "Database Lokal",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Tentang Mehr Guard Security",
    WebStringKey.ActualDomain to "Domain Sebenarnya",
    WebStringKey.AnalysisComplete to "Analisis Selesai",
    WebStringKey.AutoBlockThreatsDesc to "Blokir ancaman secara otomatis",
    WebStringKey.AwaitingScanLabel to "Menunggu Pemindaian",
    WebStringKey.BrandImpersonation to "Peniruan Merek",
    WebStringKey.CautionAdvised to "Disarankan Berhati-hati",
    WebStringKey.CompactViewDesc to "Tampilan Ringkas",
    WebStringKey.DoNotVisit to "JANGAN KUNJUNGI",
    WebStringKey.DoNotVisitDesc to "Phishing kepercayaan tinggi terdeteksi. URL ini menunjukkan beberapa indikator berbahaya.",
    WebStringKey.DomainUsesInternationalChars to "Domain ini menggunakan karakter internasional yang mungkin meniru domain yang sah.",
    WebStringKey.GoToScanner to "Pergi ke Pemindai",
    WebStringKey.Hebrew to "Ibrani",
    WebStringKey.HelpKeyboardShortcuts to "Pintasan Keyboard",
    WebStringKey.HeuristicAnalysis to "Analisis Heuristik",
    WebStringKey.HeuristicAnalysisDesc to "URL ditandai berdasarkan beberapa faktor risiko yang terdeteksi oleh mesin analisis.",
    WebStringKey.HiddenDestination to "Tujuan Tersembunyi",
    WebStringKey.HighRisk to "Risiko Tinggi",
    WebStringKey.HighRiskLabel to "RISIKO TINGGI",
    WebStringKey.HomographIdnAttack to "Serangan Homograf / IDN",
    WebStringKey.InternationalizedDomainDetected to "Nama domain internasional terdeteksi.",
    WebStringKey.JustNow to "Baru saja",
    WebStringKey.KeyboardShortcutsDesc to "Pintasan keyboard untuk akses cepat",
    WebStringKey.LiveFeedActive to "FEED LANGSUNG AKTIF",
    WebStringKey.LowRisk to "Risiko Rendah",
    WebStringKey.LowRiskLabel to "RISIKO RENDAH",
    WebStringKey.Malicious to "Berbahaya",
    WebStringKey.MediumRiskLabel to "RISIKO SEDANG",
    WebStringKey.NoData to "TIDAK ADA DATA",
    WebStringKey.NoScanDataResults to "Tidak ada data pemindaian tersedia. Silakan pindai URL untuk melihat hasil analisis.",
    WebStringKey.NoUrlScanned to "Tidak ada URL dipindai",
    WebStringKey.Persian to "Persia",
    WebStringKey.PhishingIndicators to "Indikator Phishing",
    WebStringKey.ProceedWithCaution to "LANJUTKAN DENGAN HATI-HATI",
    WebStringKey.ProceedWithCautionDesc to "Beberapa indikator mencurigakan terdeteksi. Verifikasi sumber sebelum memasukkan informasi sensitif.",
    WebStringKey.RealTimeScanningDesc to "Pemindaian real-time",
    WebStringKey.RedirectShortenerDetected to "Pengalihan/Pemendekan Terdeteksi",
    WebStringKey.SafeToVisit to "AMAN UNTUK DIKUNJUNGI",
    WebStringKey.SafeToVisitDesc to "Diverifikasi oleh heuristik lokal v2.4. Tidak ditemukan pola phishing, skrip tersembunyi, atau kecocokan daftar hitam.",
    WebStringKey.SafetyScore to "Skor Keamanan",
    WebStringKey.ScanCompleteLabel to "Pemindaian Selesai",
    WebStringKey.ScanToAnalyze to "Pindai kode QR atau masukkan URL untuk dianalisis.",
    WebStringKey.ScannedURLLabel to "URL yang Dipindai",
    WebStringKey.SecuritySignal to "Sinyal Keamanan",
    WebStringKey.SensitivityLevelDesc to "Tingkat Sensitivitas",
    WebStringKey.SensitivityPermissive to "Permisif",
    WebStringKey.SensitivityStrict to "Ketat",
    WebStringKey.SettingsDetection to "Deteksi",
    WebStringKey.SettingsDisplay to "Tampilan",
    WebStringKey.SettingsLanguage to "Bahasa",
    WebStringKey.SettingsLanguageDesc to "Pilih bahasa antarmuka",
    WebStringKey.SettingsNotifications to "Notifikasi",
    WebStringKey.SettingsSavedAutomatically to "Pengaturan disimpan secara otomatis dan disinkronkan antar sesi.",
    WebStringKey.ShowConfidenceScoreDesc to "Tampilkan skor kepercayaan",
    WebStringKey.SoundAlertsDesc to "Peringatan suara",
    WebStringKey.SuspiciousDomain to "Domain Mencurigakan",
    WebStringKey.SuspiciousEncoding to "Encoding Mencurigakan",
    WebStringKey.SuspiciousKeywords to "Kata Kunci Mencurigakan",
    WebStringKey.SuspiciousTld to "TLD Mencurigakan",
    WebStringKey.SuspiciousTldDesc to "Domain menggunakan {tld} TLD yang umumnya terkait dengan situs berbahaya.",
    WebStringKey.SuspiciousUrlParams to "Parameter URL Mencurigakan",
    WebStringKey.SuspiciousUrlParamsDesc to "URL berisi parameter kompleks atau berpotensi tersembunyi.",
    WebStringKey.ThreatAlertsDesc to "Peringatan ancaman",
    WebStringKey.ThreatDetected to "Ancaman Terdeteksi",
    WebStringKey.UnableToDetermine to "Tidak dapat menentukan keputusan. Silakan coba lagi.",
    WebStringKey.Unknown to "Tidak Dikenal",
    WebStringKey.UnknownURL to "URL Tidak Dikenal",
    WebStringKey.UrlShortenerDesc to "URL menggunakan layanan pemendekan yang menyembunyikan tujuan akhir.",
    WebStringKey.UrlShortenerDetected to "Pemendekan URL Terdeteksi",
    WebStringKey.VersionOfflineReady to "Siap offline",
    WebStringKey.VisualAppearance to "Tampilan Visual",
    WebStringKey.WaitingForAnalysisLabel to "Menunggu analisis...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "URL JavaScript",
    WebStringKey.ReasonJavascriptUrlDesc to "Skema URL JavaScript terdeteksi - mengeksekusi kode saat diklik",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "Skema Data URI terdeteksi - mungkin berisi kode berbahaya tertanam",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Injeksi Simbol @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL mengandung simbol @ menunjukkan kemungkinan upaya pencurian kredensial",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Serangan Homograf",
    WebStringKey.ReasonHomographDesc to "Nama domain internasional (IDN) mungkin meniru domain lain",
    WebStringKey.ReasonMixedScriptTitle to "Skrip Campuran",
    WebStringKey.ReasonMixedScriptDesc to "Hostname mengandung karakter dari beberapa skrip (kemungkinan spoofing)",
    WebStringKey.ReasonLookalikeCharsTitle to "Karakter Mirip",
    WebStringKey.ReasonLookalikeCharsDesc to "Domain mengandung karakter Unicode yang mirip huruf ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "Karakter Lebar Nol",
    WebStringKey.ReasonZeroWidthCharsDesc to "Karakter Unicode tersembunyi lebar nol terdeteksi (upaya penyamaran)",
    WebStringKey.ReasonIpHostTitle to "Host IP",
    WebStringKey.ReasonIpHostDesc to "URL menggunakan alamat IP bukan nama domain",
    WebStringKey.ReasonCredentialParamTitle to "Parameter Kredensial",
    WebStringKey.ReasonCredentialParamDesc to "URL mengandung parameter terkait kredensial (kata sandi, token, dll)",
    WebStringKey.ReasonBrandImpersonationTitle to "Peniruan Merek",
    WebStringKey.ReasonBrandImpersonationDesc to "URL tampaknya meniru merek terkenal",
    WebStringKey.ReasonBrandInSubdomainTitle to "Merek di Subdomain",
    WebStringKey.ReasonBrandInSubdomainDesc to "Nama merek muncul di subdomain tapi bukan domain utama",
    WebStringKey.ReasonRiskyExtensionTitle to "Ekstensi Berisiko",
    WebStringKey.ReasonRiskyExtensionDesc to "Path mengandung ekstensi file yang berpotensi berbahaya",
    WebStringKey.ReasonDoubleExtensionTitle to "Ekstensi Ganda",
    WebStringKey.ReasonDoubleExtensionDesc to "Ekstensi file ganda terdeteksi (taktik malware umum)",
    WebStringKey.ReasonEncodedPayloadTitle to "Payload Terenkode",
    WebStringKey.ReasonEncodedPayloadDesc to "Data terenkode besar terdeteksi di parameter URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP Bukan HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL menggunakan protokol HTTP tidak aman bukan HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD Mencurigakan",
    WebStringKey.ReasonSuspiciousTldDesc to "Top-level domain sering digunakan untuk phishing",
    WebStringKey.ReasonHighEntropyHostTitle to "Host Entropi Tinggi",
    WebStringKey.ReasonHighEntropyHostDesc to "Nama domain tampak dihasilkan secara acak",
    WebStringKey.ReasonRedirectParamTitle to "Parameter Redirect",
    WebStringKey.ReasonRedirectParamDesc to "URL mengandung parameter redirect yang mungkin mengarah ke situs lain",
    WebStringKey.ReasonDeepSubdomainTitle to "Subdomain Dalam",
    WebStringKey.ReasonDeepSubdomainDesc to "Kedalaman subdomain berlebihan (mungkin menyembunyikan domain asli)",
    WebStringKey.ReasonMultiTldTitle to "Multi TLD",
    WebStringKey.ReasonMultiTldDesc to "Beberapa segmen mirip TLD dalam nama domain",
    WebStringKey.ReasonNumericSubdomainTitle to "Subdomain Numerik",
    WebStringKey.ReasonNumericSubdomainDesc to "Subdomain hanya angka terdeteksi",
    WebStringKey.ReasonNonStandardPortTitle to "Port Non-Standar",
    WebStringKey.ReasonNonStandardPortDesc to "URL menggunakan nomor port non-standar",
    WebStringKey.ReasonSuspiciousPortTitle to "Port Mencurigakan",
    WebStringKey.ReasonSuspiciousPortDesc to "URL menggunakan port yang umumnya dikaitkan dengan serangan",
    WebStringKey.ReasonFragmentHidingTitle to "Penyembunyian Fragmen",
    WebStringKey.ReasonFragmentHidingDesc to "Fragmen URL tampak menyembunyikan konten tambahan",
    WebStringKey.ReasonExcessiveEncodingTitle to "Encoding Berlebihan",
    WebStringKey.ReasonExcessiveEncodingDesc to "Encoding URL berlebihan terdeteksi (upaya penyamaran)",
    WebStringKey.ReasonDomainAgePatternTitle to "Pola Usia Domain",
    WebStringKey.ReasonDomainAgePatternDesc to "Nama domain cocok dengan pola domain yang dihasilkan otomatis",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Pemendekan URL",
    WebStringKey.ReasonUrlShortenerDesc to "URL menggunakan layanan pemendekan (menyembunyikan tujuan asli)",
    WebStringKey.ReasonSuspiciousPathTitle to "Path Mencurigakan",
    WebStringKey.ReasonSuspiciousPathDesc to "Path mengandung kata kunci mencurigakan (login, verify, dll)",
    WebStringKey.ReasonLongUrlTitle to "URL Panjang",
    WebStringKey.ReasonLongUrlDesc to "URL sangat panjang tidak biasa",
    WebStringKey.ReasonCredentialKeywordsTitle to "Kata Kunci Kredensial",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL mengandung kata kunci pemanenan kredensial",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL Tidak Dapat Diparse",
    WebStringKey.ReasonUnparseableDesc to "URL tidak dapat diparse sepenuhnya",
    WebStringKey.ReasonAnalysisCompleteTitle to "Analisis Selesai",
    WebStringKey.ReasonAnalysisCompleteDesc to "Analisis berhasil diselesaikan",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "Skor Phishing ML",
    WebStringKey.MlCharacterAnalysis to "Analisis karakter",
    WebStringKey.MlFeatureAnalysis to "Analisis fitur",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "Domain IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "Domain ini menggunakan karakter internasional. Tampilan aman:",
    WebStringKey.MixedScriptAttackTitle to "Serangan Script Campuran",
    WebStringKey.MixedScriptAttackDesc to "Domain berisi karakter dari beberapa script (mis. Sirilik + Latin). Umum dalam serangan homograf.",
    WebStringKey.ConfusableCharsTitle to "Karakter yang Membingungkan",
    WebStringKey.ConfusableCharsDesc to "Domain berisi karakter yang mirip dengan huruf umum (mis. 'а' vs 'a')."
)

internal val IndonesianCommonStrings = mapOf(
    "Engine Active" to "Mesin Aktif",
    "Enterprise Protection Active" to "Perlindungan Enterprise Aktif",
    "Start New Scan" to "Mulai Pemindaian Baru",
    "Import Image" to "Impor Gambar",
    "System Health" to "Kesehatan Sistem",
    "Threat Database" to "Database Ancaman",
    "Current" to "Saat Ini",
    "Heuristic Engine" to "Mesin Heuristik",
    "Active" to "Aktif",
    "Threats" to "Ancaman",
    "Safe Scans" to "Pemindaian Aman",
    "Recent Scans" to "Pemindaian Terbaru",
    "View Full History" to "Lihat Riwayat Lengkap",
    "Status" to "Status",
    "Source" to "Sumber",
    "Details" to "Detail",
    "Time" to "Waktu",
    "SAFE" to "AMAN",
    "SUSPICIOUS" to "MENCURIGAKAN",
    "PHISHING" to "PHISHING",
    "UNKNOWN" to "TIDAK DIKETAHUI",
    "Version" to "Versi",
    "Last Update" to "Pembaruan Terakhir",
    "Signatures" to "Tanda Tangan",
    "Check for Updates" to "Periksa Pembaruan",
    "Active Scanner" to "Pemindai Aktif",
    "Offline Mode" to "Mode Offline",
    "Camera Access Required" to "Akses Kamera Diperlukan",
    "Enable Camera" to "Aktifkan Kamera",
    "Scanning..." to "Memindai...",
    "Torch" to "Senter",
    "Gallery" to "Galeri",
    "Paste URL" to "Tempel URL",
    "Analyze URL" to "Analisis URL",
    "Analyze" to "Analisis",
    "READY" to "SIAP",
    "Local DB" to "DB Lokal",
    "Latency" to "Latensi",
    "View All" to "Lihat Semua",
    "Dashboard" to "Dasbor",
    "Settings" to "Pengaturan",
    "Training Centre" to "Pusat Pelatihan",
    "Beat the Bot" to "Kalahkan Bot",
    "Safe" to "Aman",
    "Suspicious" to "Mencurigakan",
    "Dangerous" to "Berbahaya",
    "Phishing" to "Phishing",
    "Legitimate" to "Sah",
    "Block & Report" to "Blokir & Laporkan",
    "Copy Link" to "Salin Tautan",
    "Share" to "Bagikan",
    "Export Report" to "Ekspor Laporan",
    "Clear All" to "Hapus Semua",
    "Cancel" to "Batal",
    "Close" to "Tutup",
    "Back to Dashboard" to "Kembali ke Dasbor",
    "Scan Complete" to "Pemindaian Selesai",
    "High Risk" to "Risiko Tinggi",
    "Low Risk" to "Risiko Rendah",
    "Risk Score" to "Skor Risiko",
    "Confidence" to "Kepercayaan",
    "Homograph Attack" to "Serangan Homograf",
    "Detected" to "Terdeteksi",
    "Bahasa Indonesia" to "Bahasa Indonesia"
)
